export const version = '10.15.1';
export function init() {
  if (typeof window !== 'undefined') {
    class Eufemia {
      get version() {
        return '10.15.1';
      }
    }
    window.Eufemia = new Eufemia();
  }
}
//# sourceMappingURL=Eufemia.js.map